type Listener = () => void

const listeners = new Set<Listener>()

/** Notifies `useSyncExternalStore` subscribers when theme preference changes. */
export const themePreferenceStore = {
  subscribe(listener: Listener): () => void {
    listeners.add(listener)
    return () => {
      listeners.delete(listener)
    }
  },
  notify(): void {
    listeners.forEach((listener) => {
      listener()
    })
  }
}
